import gql from 'graphql-tag'

const getGoogleUserData = gql`
  query getGoogleUserData($workspace_id: Float!) {
    getGoogleUserData(workspace_id: $workspace_id) {
      id
      google_id
      email
      verified_email
      name
      given_name
      family_name
      picture
      locale
      refresh_token
    }
  }
`

export default getGoogleUserData
